var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"list"}),(_vm.showNoContent)?_c('no-content',{attrs:{"msg":'暂无活动'}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }